import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import {
  AttachmentItem,
  LoadImpact,
  TicketLevel,
  UrgencyLevel,
  addSubmitTicketAttachment,
  attachSubmitTicketToIssue,
  setSubmitTicketTriggerFieldValue,
  removeSubmitTicketAttachment,
  resetSubmitTicketState,
  setSubmitTicketCategory,
  setSubmitTicketDescription,
  setSubmitTicketImpactedPeople,
  setSubmitTicketLevel,
  setSubmitTicketLoadImpact,
  setSubmitTicketLevelReference,
  setSubmitTicketSapId,
  setSubmitTicketStatusMessage,
  setSubmitTicketStakeholders,
  setSubmitTicketSubCategory,
  setSubmitTicketTertiaryCategory,
  setSubmitTicketSubmitter,
  setSubmitTicketTitle,
  setSubmitTicketUrgency,
  setSubmitTicketMmsToggle,
} from "../../../store/slices/ticketingPortalSlice";

const useSubmitTicketForm = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { draft, attachedIssueIds, triggerValues, statusMessage, statusTone } = useSelector((state: RootState) => ({
    draft: state.ticketingPortal.submitTicketDraft,
    attachedIssueIds: state.ticketingPortal.submitTicketAttachedIssueIds,
    triggerValues: state.ticketingPortal.submitTicketTriggerValues,
    statusMessage: state.ticketingPortal.submitTicketStatusMessage,
    statusTone: state.ticketingPortal.submitTicketStatusTone,
  }));

  return {
    draft,
    attachedIssueIds,
    triggerValues,
    statusMessage,
    statusTone,
    setTitle: (value: string) => dispatch(setSubmitTicketTitle(value)),
    setDescription: (value: string) => dispatch(setSubmitTicketDescription(value)),
    setSubmitter: (value: string) => dispatch(setSubmitTicketSubmitter(value)),
    setStakeholders: (value: string) => dispatch(setSubmitTicketStakeholders(value)),
    setCategory: (value: string) => dispatch(setSubmitTicketCategory(value)),
    setSubCategory: (value: string) => dispatch(setSubmitTicketSubCategory(value)),
    setTertiaryCategory: (value: string) => dispatch(setSubmitTicketTertiaryCategory(value)),
    setLevel: (value: TicketLevel) => dispatch(setSubmitTicketLevel(value)),
    setLevelReference: (value: string) => dispatch(setSubmitTicketLevelReference(value)),
    setSapId: (value: string) => dispatch(setSubmitTicketSapId(value)),
    setUrgency: (value: UrgencyLevel) => dispatch(setSubmitTicketUrgency(value)),
    setImpactedPeople: (value: string) => dispatch(setSubmitTicketImpactedPeople(value)),
    setLoadImpact: (value: LoadImpact) => dispatch(setSubmitTicketLoadImpact(value)),
    setTriggerFieldValue: (fieldName: string, value: string) =>
      dispatch(setSubmitTicketTriggerFieldValue({ fieldName, value })),
    attachToIssue: (issueId: string) => dispatch(attachSubmitTicketToIssue(issueId)),
    addAttachment: (attachment: AttachmentItem) => dispatch(addSubmitTicketAttachment(attachment)),
    removeAttachment: (attachmentId: string) => dispatch(removeSubmitTicketAttachment(attachmentId)),
    setMmsToggle: (value: boolean) => dispatch(setSubmitTicketMmsToggle(value)),
    resetSubmitTicket: () => dispatch(resetSubmitTicketState()),
    setStatusMessage: (message: string | null, tone: "info" | "success" | "error" | null) =>
      dispatch(setSubmitTicketStatusMessage({ message, tone })),
  };
};

export default useSubmitTicketForm;
